<template>
    <div class="card-list-item" tabindex="-1">
        <div class="main">
            <dynamic-display :load-data-api="getLoadDataApi()" @loadEnd="onLoadEnd" :load-data-on-created="true"
                             ref="dynamicDisplay" class="dynamic-display">
                <template v-slot:showResultsContainer>
                    <template v-if="itemDetail">
                        <div class="line">
                            <div class="left highlight">{{ itemDetail.capacities.join(', ') }}</div>
                            <div class="text-gray right" :title="itemDetail.durationFull">{{
                                    itemDetail.durationShort
                                }}
                            </div>
                        </div>
                        <div class="line">
                            <div class="left">
                                <span v-if="itemDetail.stockCodes.length">{{ itemDetail.stockCodes.join(', ') }} &bullet; </span>
                                {{ itemDetail.companyName }}<span
                                    class="text-gray"> ({{ itemDetail.companyId }})</span></div>
                            <div class="text-gray text-uppercase text-nowrap">{{ itemDetail.source }}</div>
                        </div>
                        <div class="line">
                            <span class="text-gray">Index ID: {{ indexId }}</span>
                        </div>
                    </template>
                    <span v-else>Index ID "{{ indexId }}" doesn't exist in AdminHK</span>
                </template>
            </dynamic-display>
        </div>
        <div class="controls">
            <button class="pure" @click="removeItem"><i class="gf gf-close"></i></button>
        </div>
    </div>
</template>

<script>
import DynamicDisplay from "@/components/DynamicDisplay";
import {getPersonCapacityData} from "@/apis";
import {dateObjectToDateString, evaluateValueFilled} from "@/utils";

export default {
    name: "CapacityRow",
    components: {DynamicDisplay},
    props: {
        indexId: Number,
    },
    data() {
        return {
            itemDetail: null,
        }
    },
    methods: {
        getLoadDataApi() {
            return getPersonCapacityData.bind(null, this.indexId);
        },
        onLoadEnd(showingResults, results) {
            if (results) {
                this.itemDetail = this.transformItemDetail(results);
            } else {
                this.itemDetail = null;
            }
        },
        transformItemDetail(itemDetail) {
            const {Capacity_gekko, End, Gekko_name_en, Gekko_name_ch, Source, Start, Stock_code, Gekko_id_company} = itemDetail;
            let capacities, durationShort, durationFull, stockCodes, companyName, companyId, source, dateStart, dateEnd;
            if (Capacity_gekko) {
                capacities = Capacity_gekko.split('|');
            } else {
                capacities = [];
            }

            if (evaluateValueFilled(Start)) {
                dateStart = dateObjectToDateString(new Date(Start * 1000));
            }

            if (evaluateValueFilled(End)) {
                dateEnd = dateObjectToDateString(new Date(End * 1000));
            }

            durationFull = `${dateStart || '?'} ~ ${dateEnd || 'present'}`;
            durationShort = `${dateStart && dateStart.substr(0, 4) || '?'} - ${dateEnd && dateEnd.substr(0, 4) || 'present'}`;

            if (Stock_code) {
                stockCodes = Stock_code.split('|');
            } else {
                stockCodes = [];
            }

            companyName = Gekko_name_en || Gekko_name_ch;

            companyId = Gekko_id_company;

            source = Source;

            return {
                capacities,
                durationShort,
                durationFull,
                stockCodes,
                companyName,
                companyId,
                source,
            }
        },
        removeItem() {
            this.$emit('removeItem', this.indexId);
        },
        focus() {
            this.$el.focus();
        }
    }
}
</script>

<style scoped lang="scss">
@import "../assets/variables";
</style>
